import { TOUR_AVAILABLE } from "../actions/types";

const INITIAL_STATE = {isTourAvailable: -1, activateTour: -1};

export default (state = INITIAL_STATE, action) => {

    if(action.type === TOUR_AVAILABLE)
    {
        // console.log("form action button write", action);

        if(action.payload){
            const isTourAvailable = action.payload.isTourAvailable;

            const newState = {...state};

            newState.isTourAvailable = isTourAvailable === -1 ? newState.isTourAvailable : isTourAvailable;
            newState.activateTour = action.payload.activateTour || -1;

            return newState;
        }
    }

    return state;
}
